import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useBeforeAfter = () => {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    axios.get(`${API}/before-after`).then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, []);
  return { items, loaded };
};

const BeforeAfterSection = ({ preview = false }) => {
  const { t } = useLanguage();
  const { items, loaded } = useBeforeAfter();
  const labels = { before: t.beforeAfter.before, after: t.beforeAfter.after };
  const shown = preview ? items.slice(0, 2) : items;

  if (preview && loaded && items.length === 0) return null;

  return (
    <section className="py-24 sm:py-32" data-testid={preview ? "before-after-preview-section" : "before-after-section"}>
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <SectionHead overline={t.beforeAfter.overline} title={t.beforeAfter.title} accent={t.beforeAfter.titleAccent} sub={t.beforeAfter.sub} />
          {preview && (
            <Reveal delay={0.2}>
              <Link to="/galerie" data-testid="before-after-preview-cta" className="group flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-gold transition-colors hover:text-gold-hover">
                {t.beforeAfter.cta}
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
              </Link>
            </Reveal>
          )}
        </div>

        {loaded && items.length === 0 && (
          <Reveal>
            <p className="mt-14 rounded-3xl border-2 border-dashed border-brand/20 px-6 py-12 text-center text-forest" data-testid="before-after-empty">
              {t.beforeAfter.empty}
            </p>
          </Reveal>
        )}

        <div className="mt-14 grid gap-8 md:grid-cols-2">
          {shown.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.1}>
              <BeforeAfterSlider item={item} labels={labels} testid={`before-after-slider-${i}`} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
